import { isStaging } from '@/core/utilities';

export default class OauthService {
  /** @ngInject **/
  constructor(
    $http,
    ngAuthSettings,
    integrationService
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.integrationService = integrationService;
  }

  getAuthUrl(accountId, provider) {
    if (isStaging) {
      return import(/* webpackChunkName: "staging" */ './MockIntegrationService').then(function ({ default: mockIntegrationService }) {
        return mockIntegrationService.getAuthUrl();
      });
    }
    return this.$http.get(this.#serviceUserBaseUrl(accountId) + '/' + this.integrationService.getProviderUrlMap(provider.toLowerCase()) + '/authurl');
  }

  saveOauthData(accountId, provider, data) {
    if (isStaging) {
      return import(/* webpackChunkName: "staging" */ './MockIntegrationService').then(function ({ default: mockIntegrationService }) {
        return mockIntegrationService.saveOauthData();
      });
    }
    return this.$http.post(this.#serviceUserBaseUrl(accountId) + '/' + this.integrationService.getProviderUrlMap(provider) + '/callback', data);
  }

  #serviceUserBaseUrl(accountId) {
    return this.ngAuthSettings.apiServiceBaseUri + accountId + '/oauth';
  }
}